import { supabase } from '@/integrations/supabase/client';

let isInitialized = false;
let initializationPromise: Promise<void> | null = null;

export async function setupDatabase() {
  // If already initialized, return immediately
  if (isInitialized) {
    return;
  }

  // If initialization is in progress, wait for it
  if (initializationPromise) {
    return initializationPromise;
  }

  // Create a new initialization promise
  initializationPromise = (async () => {
    try {
      // Test connection with a simple query that doesn't require auth
      const { data, error } = await supabase
        .from('platform_metrics')
        .select('count')
        .limit(1)
        .single();

      if (error) {
        console.error('Error connecting to Supabase:', error);
        return;
      }

      // Mark as initialized after successful connection
      isInitialized = true;
    } catch (error) {
      console.error('Error during database setup:', error);
      // Don't set isInitialized to true if there was an error
    } finally {
      // Clear the initialization promise
      initializationPromise = null;
    }
  })();

  return initializationPromise;
}

// This function is disabled to prevent errors with non-existent tables
async function addSampleData() {
  console.log('Sample data addition is disabled to prevent errors with non-existent tables');
  return;
  
  // The code below is kept for reference but will not execute
  try {
    // Add sample business progress - disabled
    console.log('Would add sample business data here if enabled');
    
    // Add some platform metrics if none exist - disabled
    console.log('Would add platform metrics here if enabled');
    
    console.log('Sample data would be added successfully if enabled');
  } catch (error) {
    console.error('Error adding sample data:', error);
  }
}
